import './MIc.css';
import React, { useState, useEffect } from "react";
import Axios from "axios";
const API_KEY = '1d80089c';

const MovieInfoComponent = (props) => {
  const [movieInfo, setMovieInfo] = useState();
  const { selectedMovie } = props;

  useEffect(() => {
    Axios.get(
      `https://www.omdbapi.com/?i=${selectedMovie}&apikey=${API_KEY}`,
    ).then((response) => setMovieInfo(response.data));
  }, [selectedMovie]);
  return (
    <div className='Mi_Container'>
      {movieInfo ? (
        <>
          <img className='Mi_CoverImage' src={movieInfo?.Poster} alt={movieInfo?.Title} />
          <div className='InfoColumn'>
            <div className='MovieName'>
              {movieInfo?.Type}: <span>{movieInfo?.Title}</span>
            </div>
            <div className='movieInfo'>
              IMDB Rating: <span>{movieInfo?.imdbRating}</span>
            </div>
            <div className='movieInfo'>
              Year: <span>{movieInfo?.Year}</span>
            </div>
            <div className='movieInfo'>
              Language: <span>{movieInfo?.Language}</span>
            </div>
            <div className='movieInfo'>
              Rated: <span>{movieInfo?.Rated}</span>
            </div>
            <div className='movieInfo'>
              Released: <span>{movieInfo?.Released}</span>
            </div>
            <div className='movieInfo'>
              Runtime: <span>{movieInfo?.Runtime}</span>
            </div>
            <div className='movieInfo'>
              Genre: <span>{movieInfo?.Genre}</span>
            </div>
            <div className='movieInfo'>
              Director: <span>{movieInfo?.Director}</span>
            </div>
            <div className='movieInfo'>
              Actors: <span>{movieInfo?.Actors}</span>
            </div>
            <div className='movieInfo'>
              Plot: <span>{movieInfo?.Plot}</span>
            </div>
          </div>
          <div className='Close' onClick={() => props.onMovieSelect()}>close</div>
        </>
      ) : (
        "Hover..."
      )}
    </div>
  );
};
export default MovieInfoComponent;